import SectionWrapper from "./SectionWrapper"
import ConsultBookMobile from "../../../assets/images/client-manual/ConsultBookMobile.jpg"
import ConsultMobile from "../../../assets/images/client-manual/ConsultMobile.png"
import PickTimeMobile from "../../../assets/images/client-manual/PickTimeMobile.png"
import ConsultConfirmMobile from "../../../assets/images/client-manual/ConsultConfirmMobile.jpg"
import ConsultBookMobilePopUp from "../../../assets/images/client-manual/ConsultBookMobilePopUp.jpg"
import ScheduledMobile from "../../../assets/images/client-manual/ScheduledMobile.png"
import MobileHamburger from "../../../assets/images/client-manual/MobileHamburger.png"
import MyCoachesMobile from "../../../assets/images/client-manual/MyCoachesMobile.png"
import SelectCoachMobile from "../../../assets/images/client-manual/SelectCoachMobile.png"
import ContactConsult from "../../../assets/images/client-manual/ContactConsult.png"
import ContactSeeAll from "../../../assets/images/client-manual/ContactSeeAll.png"
import SeeDetailsMobile from "../../../assets/images/client-manual/SeeDetailsMobile.png"
import EnrollServiceMobile from "../../../assets/images/client-manual/EnrollServiceMobile.png"
import PromoMobile from "../../../assets/images/client-manual/PromoMobile.png"
import PayNowMobile from "../../../assets/images/client-manual/PayNowMobile.png"
import PendingMobile from "../../../assets/images/client-manual/PendingMobile.png"
import AcceptMobile from "../../../assets/images/client-manual/AcceptMobile.png"
import SchedMobile from "../../../assets/images/client-manual/SchedMobile.png"
import NextMobile from "../../../assets/images/client-manual/NextMobile.png"
import ConfirmTimeMobile from "../../../assets/images/client-manual/ConfirmTimeMobile.png"
import SchedLater from "../../../assets/images/client-manual/SchedLater.png"
import RecurringMobile from "../../../assets/images/client-manual/RecurringMobile.png"
import CalendarNavMobile from "../../../assets/images/client-manual/CalendarNavMobile.png"
import ReschedMobile from "../../../assets/images/client-manual/ReschedMobile.png"
import ReschedPageMobile from "../../../assets/images/client-manual/ReschedPageMobile.png"
import CalendarSchedMobile from "../../../assets/images/client-manual/CalendarSchedMobile.png"
import CancelSchedMobile from "../../../assets/images/client-manual/CancelSchedMobile.png"
import CalMobile from "../../../assets/images/client-manual/CalMobile.png"

export default function CMSchedulingMobile() {
  return (
    <SectionWrapper id="scheduling">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-900 md:text-5xl">
          Booking & Managing{" "}
          <span className="text-[#4750F5]">Sessions and Appointments</span>
        </h1>
        <p className="text-gray-700 mt-8 text-center">
          You can book sessions in Zoee by booking via a{" "}
          <a
            href="#book-profile"
            className="text-[#4750F5] underline font-semibold hover:text-[#3742d9]"
          >
            coach's profile{" "}
          </a>
          or using the{" "}
          <a
            href="#book-dropdown"
            className="text-[#4750F5] underline font-semibold hover:text-[#3742d9]"
          >
            scheduling dropdown.{" "}
          </a>
          You can also{" "}
          <a
            href="#reschedule-session"
            className="text-[#4750F5] underline font-semibold hover:text-[#3742d9]"
          >
            reschedule{" "}
          </a>
          or{" "}
          <a
            href="#cancel-session"
            className="text-[#4750F5] underline font-semibold hover:text-[#3742d9]"
          >
            cancel{" "}
          </a>
          a session.
        </p>
      </div>

      <div className="mt-8 bg-blue-50 p-6 rounded-lg w-full">
        <h3 id="book-profile" className="text-2xl font-semibold text-blue-700">
          Booking Sessions With Your Coach
        </h3>
      </div>

      <div className="bg-white p-6 rounded-lg mt-[-24px]">
        <h4 className="text-xl font-semibold text-gray-700 mb-4">
          Book Consultation via Coach's Zoee Website
        </h4>
        <p>
          You will have received a link from your coach inviting you to view
          their Zoee profile by email or text. You can book a consultation using
          the following steps:
        </p>
        <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-2">
          <li>Click on the link provided to you by your coach.</li>
          <li>
            Click on the “Book a Consult” sidebar item on the left-hand side of
            your screen.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={ConsultMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            Pick a day and time that is convenient for you and click the “Book”
            button.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={PickTimeMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            Fill out the appropriate information in the continue as guest
            section of the new page.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={ConsultConfirmMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            Click on the <strong>"Book"</strong> button.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={ConsultBookMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            A pop up will appear to confirm you have successfully booked with your coach.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={ConsultBookMobilePopUp}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
        </ul>
      </div>

      <div className="mt-8 bg-blue-50 p-6 rounded-lg w-full">
        <h4 id="book-dropdown" className="text-xl font-semibold text-blue-700">
          Book Consultation via Coach Contact Card
        </h4>
      </div>
      <div className="bg-white p-6 rounded-lg mt-[-24px]">
        <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-0">
          <li>
            From the Homepage, click on the hamburger menu on the top left of
            the screen.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={MobileHamburger}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>Select “My Coaches” from the emerging side menu.</li>
          <div className="flex justify-center mt-4">
            <img
              src={MyCoachesMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>Select Your Coach.</li>
          <div className="flex justify-center mt-4">
            <img
              src={SelectCoachMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            Click on the dropdown button labeled “Schedule with Coach.” This
            will produce 2 options: “See all Services” and “Consultation.”
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={ContactConsult}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>Click on the “Consultation” button from the dropdown menu.</li>
          <li>Select a time on the new page.</li>
          <li>Click on the “Next” button.</li>
          <li>
            Review the event details on the page and click the “Confirm” button
            to complete scheduling.
          </li>
        </ul>
      </div>

      <h4 className="text-2xl font-semibold text-blue-700 mt-8">
        Purchasing Services
      </h4>
      <div className="bg-white p-6 rounded-lg mt-[-24px]">
        <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-4">
          <li>
            Click on the “See All Services” button from the dropdown menu.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={ContactSeeAll}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            Click on the “See Details” button for the service you want to
            purchase.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={SeeDetailsMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>Click on the “Enroll in Service” button on the page.</li>
          <div className="flex justify-center mt-4">
            <img
              src={EnrollServiceMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            Optional: If you were provided with a promocode, click on the “Add
            promocode” button and insert the code in the appearing space.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={PromoMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>Review the details of your purchase.</li>
          <li>
            Pay through PayPal or by entering your card details and clicking the
            “Pay now” button.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={PayNowMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>A pop-up confirming your enrollment should appear.</li>
        </ul>
      </div>

      <h4 className="text-2xl font-semibold text-blue-700 mt-8 mb-4">
        Invited to Service
      </h4>
      <div className="bg-white p-6 rounded-lg mt-[-24px]">
        <p>
          You will receive an email or text informing you that your coach has
          invited you to a service, and prompting you to sign into your account.
          To view the invitation, follow these steps:
        </p>
        <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-2">
          <li>Log into Zoee.</li>
          <li>
            From the Homepage, click on the hamburger menu on the top left of
            the screen.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={MobileHamburger}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>Select “My Coaches” from the emerging side menu.</li>
          <div className="flex justify-center mt-4">
            <img
              src={MyCoachesMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>Select your coach.</li>
          <div className="flex justify-center mt-4">
            <img
              src={SelectCoachMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            Scroll down the page to the “Services I enrolled into” section.
          </li>
          <li>
            Click on the “Pending” button. It will have a notification
            identifier beside it.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={PendingMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>Click on either the “Accept invite” button.</li>
          <div className="flex justify-center mt-4">
            <img
              src={AcceptMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>Review the details of your purchase.</li>
          <li>
            Pay through PayPal or by entering your card details and clicking the
            “Pay now” button.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={PayNowMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>A pop-up confirming your enrollment should appear.</li>
          <li>
            Click on the "Schedule" button of the pop-up confirming your
            enrollment after purchasing a service.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={SchedMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            Browse the available times and select a time that works for you then
            click the next button.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={NextMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            Review the event details on the page and click the “Confirm” button
            to complete scheduling.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={ConfirmTimeMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
        </ul>
      </div>

      <h4 className="text-2xl font-semibold text-blue-700 mt-8 mb-4">
        Booking Session After Purchasing Service
      </h4>
      <div className="bg-white p-6 rounded-lg mt-[-24px]">
        <p>
          You can schedule your session for your service either immediately
          after purchasing or at a later time.
        </p>
        <h4 className="text-xl font-semibold text-blue-700 mt-8 mb-2">
          1. After purchasing
        </h4>
        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li>
            Click on the "Schedule" button of the pop-up confirming your
            enrollment after purchasing a service.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={SchedMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            Browse the available times and select a time that works for you then
            click the next button.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={NextMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            Review the event details on the page and click the “Confirm” button
            to complete scheduling.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={ConfirmTimeMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
        </ul>
        <h4 className="text-xl font-semibold text-blue-700 mt-8 mb-2">
          2. Scheduling at a later time
        </h4>
        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li>Log into Zoee.</li>
          <li>
            From the Homepage, click on the hamburger menu on the top left of
            the screen.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={MobileHamburger}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>Select “My Coaches” from the emerging side menu.</li>
          <div className="flex justify-center mt-4">
            <img
              src={MyCoachesMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>Select your coach.</li>
          <div className="flex justify-center mt-4">
            <img
              src={SelectCoachMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            Navigate down their page to the “Services I enrolled into” section.
          </li>
          <li>
            Locate the service you want to schedule a session for and click the
            “Schedule Session”.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={SchedLater}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            Browse the available times and select a time that works for you then
            click the next button.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={NextMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            Review the event details on the page and click the “Confirm” button
            to complete scheduling.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={ConfirmTimeMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
        </ul>
      </div>

      <h4 className="text-2xl font-semibold text-blue-700 mt-8 mb-4">
        Scheduling Recurring Sessions
      </h4>
      <div className="bg-white p-6 rounded-lg mt-[-24px]">
        <p>
          For a recurring service purchased from your coach, you or your coach
          will need to schedule the next session till the total amount of
          sessions has been redeemed. For each session you need to schedule, you
          can follow these steps:
        </p>
        <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-2">
          <li>Log into Zoee.</li>
          <li>
            From the Homepage, click on the hamburger menu on the top left of
            the screen.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={MobileHamburger}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>Select “My Coaches” from the emerging side menu.</li>
          <div className="flex justify-center mt-4">
            <img
              src={MyCoachesMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>Select your coach.</li>
          <div className="flex justify-center mt-4">
            <img
              src={SelectCoachMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            Scroll down the page to the “Services I enrolled into” section.
          </li>
          <li>Select the service you want to schedule a session for.</li>
          <div className="flex justify-center mt-4">
            <img
              src={RecurringMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            Browse the available times and select a time that works for you then
            click the next button.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={NextMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            Review the event details on the page and click the “Confirm” button
            to complete scheduling.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={ConfirmTimeMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li className="italic">
            If you encounter a problem scheduling sessions in a recurring
            package, reach out to Zoee support..
          </li>
        </ul>
      </div>

      <h4
        id="reschedule-session"
        className="text-2xl font-semibold text-blue-700 mt-8"
      >
        Rescheduling your Session
      </h4>
      <div className="bg-white p-6 rounded-lg mt-[-24px]">
        <h4 className="text-xl font-semibold text-blue-700 mt-4">
          From the Homepage
        </h4>
        <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-2">
          <li>Log into Zoee.</li>
          <li>
            Click on the “Reschedule session” button on the session displayed on
            the calendar.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={ReschedMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>Scroll down to the When section.</li>
          <li>Click on the “Reschedule” button.</li>
          <div className="flex justify-center mt-4">
            <img
              src={ReschedPageMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            Browse the available times and select a new time that works for you
            then click the next button
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={NextMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            Review the event details on the page and click the “Confirm” button
            to complete scheduling.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={ConfirmTimeMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
        </ul>
        <h4 className="text-xl font-semibold text-blue-700 mt-8">
          From My Calendar
        </h4>
        <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-2">
          <li>Log into Zoee.</li>
          <li>
            From the Homepage, click on the hamburger menu on the top left of
            the screen.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={MobileHamburger}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>Select “My Calendar” from the emerging side menu.</li>
          <div className="flex justify-center mt-4">
            <img
              src={CalMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            Click on the “Manage sessions” button on the session displayed on
            the page.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={CalendarSchedMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>Scroll down to the When section.</li>
          <li>Click on the “Reschedule” button.</li>
          <div className="flex justify-center mt-4">
            <img
              src={ReschedPageMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            Browse the available times and select a new time that works for you
            then click the next button
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={NextMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            Review the event details on the page and click the “Confirm” button
            to complete scheduling.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={ConfirmTimeMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
        </ul>
      </div>

      <h4
        id="cancel-session"
        className="text-2xl font-semibold text-blue-700 mt-8"
      >
        Cancelling your session
      </h4>
      <div className="bg-white p-6 rounded-lg mt-[-14px] ">
        <p>
          We understand that plans can change unexpectedly, and you may need to
          cancel a scheduled session. Here are the steps you can take to do so.
        </p>
        <h4 className="text-xl font-semibold text-blue-700 mt-8">
          From the Homepage
        </h4>
        <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-2">
          <li>Log into Zoee.</li>
          <li>
            Click on the “Reschedule session” button on the session displayed on
            the calendar.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={ReschedMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>Scroll down to the When section.</li>
          <li>Click on the “Cancel Meeting” button.</li>
          <div className="flex justify-center mt-4">
            <img
              src={CalendarSchedMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            You will see a quick popup confirming your meeting has been
            successfully cancelled.
          </li>
        </ul>
        <h4 className="text-xl font-semibold text-blue-700 mt-8">
          From My Calendar
        </h4>
        <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-2">
          <li>Log into Zoee.</li>
          <li>
            From the Homepage, click on the hamburger menu on the top left of
            the screen.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={MobileHamburger}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>Select “My Calendar” from the emerging side menu.</li>
          <div className="flex justify-center mt-4">
            <img
              src={CalMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            Click on the “Manage sessions” button on the session displayed on
            the page.
          </li>
          <div className="flex justify-center mt-4">
            <img
              src={CalendarSchedMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>Scroll down to the When section.</li>
          <li>Click on the "Cancel" button.</li>
          <div className="flex justify-center mt-4">
            <img
              src={CancelSchedMobile}
              alt="Profile Dropdown Example"
              className="w-full max-w-md rounded-lg"
            />
          </div>
          <li>
            You will see a quick popup confirming your meeting has been
            successfully cancelled.
          </li>
        </ul>
      </div>
    </SectionWrapper>
  )
}
